/* eslint-disable */

// help for codes :
// https://www.wikiwand.com/fr/Liste_des_codes_ISO_639-1

interface TranslationEntry {
  skipOrContinue?: {
    message: string;
    confirm: string;
    cancel: string;
  };
  confirmSkip?: {
    message: string;
    confirm: string;
    cancel: string;
  };
  optIn?: {
    message?: string;
    confirm?: string;
    cancel?: string;
  };
  discover: string;
  wait: string;
  wait_close: string;
  continue: string;
  click_bookmark: string;
  call_to_action: string;
}

const translations: Translations<TranslationEntry> = {
  // english
  en: {
    skipOrContinue: {
      message: 'Skip the video ?',
      confirm: 'Skip',
      cancel: 'No'
    },
    confirmSkip: {
      message: 'What do you want to do ?',
      confirm: 'Skip the video',
      cancel: 'Visit the website'
    },
    optIn: {
      message:
        "If you close the ad, you won't receive your reward. Are you sure ?",
      confirm: 'Skip',
      cancel: 'No'
    },
    discover: '<span>Discover <strong>#{name}</strong>.</span>',
    wait: '<span>Your content will resume in <strong>#{count}</strong></span>',
    wait_close: 'Close in <strong>#{count} sec</strong>',
    continue: 'Continue',
    click_bookmark: 'Click to bookmark',
    call_to_action: 'Visit website'
  },
  // french
  fr: {
    skipOrContinue: {
      message: 'Passer la vidéo ?',
      confirm: 'Passer',
      cancel: 'Non'
    },
    confirmSkip: {
      message: 'Que voulez vous faire ?',
      confirm: 'Quitter la vidéo',
      cancel: 'Visiter le site'
    },
    optIn: {
      message:
        "Si vous fermez la publicité vous n'obtiendrez pas votre récompense, êtes-vous sûr ?",
      confirm: 'Passer',
      cancel: 'Non'
    },
    discover: '<span>Découvrez <strong>#{name}</strong>.</span>',
    wait:
      '<span>Veuillez patienter - Votre contenu dans <strong>#{count}</strong></span>',
    wait_close: 'Fermeture dans <strong>#{count} sec</strong>',
    continue: 'Continuer',
    click_bookmark: 'Ajouter aux favoris',
    call_to_action: 'Visiter le site'
  },
  // German
  de: {
    skipOrContinue: {
      message: 'Video überspringen ?',
      confirm: 'Überspringen',
      cancel: 'Nein'
    },
    confirmSkip: {
      message: 'Was möchten Sie tun?',
      confirm: 'Video überspringen',
      cancel: 'Website besuchen'
    },
    optIn: {
      message:
        'Wenn Sie die Anzeige schließen erhalten Sie keine Prämie. Sind Sie sicher?',
      confirm: 'Überspringen',
      cancel: 'Nein'
    },
    discover: '<span><strong>#{name}</strong> entdecken.</span>',
    wait:
      '<span>Bitte warten - Ihr Inhalt wird in <strong>#{count}</strong></span>',
    wait_close: 'Schließen in <strong>#{count} Sekunden</strong>',
    continue: 'Weiter',
    click_bookmark: 'Den favoriten hinzufügen',
    call_to_action: 'Website besuchen'
  },
  // italian
  it: {
    skipOrContinue: {
      message: 'Salta il video ?',
      confirm: 'Salta',
      cancel: 'No'
    },
    confirmSkip: {
      message: 'Cosa vuoi fare?',
      confirm: 'Salta il video',
      cancel: 'Visita il sito'
    },
    optIn: {
      message:
        'Se interrompi la pubblicità, non otterrai la tua ricompensa. Sei sicuro?',
      confirm: 'Salta',
      cancel: 'No'
    },
    discover: '<span>Scopri <strong>#{name}</strong>.</span>',
    wait:
      '<span>Attendi - Il tuo contenuto tra <strong>#{count}</strong></span>',
    wait_close: 'Chiudere tra <strong>#{count} secondi</strong>',
    continue: 'Continua',
    click_bookmark: 'Aggiungi ai preferiti',
    call_to_action: 'Visita il sito'
  },
  // espagnol
  es: {
    skipOrContinue: {
      message: '¿ Saltar el video ?',
      confirm: 'Saltar',
      cancel: 'No'
    },
    confirmSkip: {
      message: '¿Qué quieres hacer?',
      confirm: 'Saltar el video',
      cancel: 'Visitar la página web'
    },
    optIn: {
      message:
        'Si cierras la publicidad, no obtendrás la recompensa. ¿Estás seguro?',
      confirm: 'Saltar',
      cancel: 'No'
    },
    discover: '<span>Descubrir <strong>#{name}</strong>.</span>',
    wait:
      '<span>Por favor, espere - El contenido en <strong>#{count}</strong></span>',
    wait_close: 'Cerrar en <strong>#{count} segundos</strong>',
    continue: 'Continuar',
    click_bookmark: 'Añadir en la pantalla inicial',
    call_to_action: 'Visitar la página web'
  },
  // russe
  ru: {
    skipOrContinue: {
      message: 'Пропустить видео ?',
      confirm: 'Пропустить',
      cancel: 'Нет'
    },
    confirmSkip: {
      message: 'Что вы хотите сделать?',
      confirm: 'Пропустить видео',
      cancel: 'Посетить веб-сайт'
    },
    optIn: {
      message:
        'В случае закрытия рекламы вы не получите вознаграждение. Вы уверены?',
      confirm: 'Пропустить',
      cancel: 'Нет'
    },
    discover: '#{name}',
    wait:
      '<span>Пожалуйста, подождите содержимое <strong>#{count}</strong></span>',
    wait_close: 'Закроется через <strong>#{count} сек</strong>',
    continue: 'Продолжить',
    click_bookmark: 'Добавить в закладку',
    call_to_action: 'Посетить веб-сайт'
  },
  // arabe
  ar: {
    skipOrContinue: {
      message: 'تخطى الفيديو؟',
      confirm: 'تخطى',
      cancel: 'لا'
    },
    confirmSkip: {
      message: 'ماذا تريد أن تفعل؟',
      confirm: 'تخطى الفيديو',
      cancel: 'قم بزيارة الموقع'
    },
    optIn: {},
    discover: '#{name}',
    wait: '<span><strong>#{count}</strong> يرجى انتظار الصفحة خلال</span>',
    wait_close: '<strong>ثانية  #{count}</strong> يغلق خلال',
    continue: 'أكمل',
    click_bookmark: 'أضف كمرجع على الجوال',
    call_to_action: 'قم بزيارة الموقع'
  },
  // chinois
  zh: {
    skipOrContinue: {
      message: '跳过视频？',
      confirm: '跳过',
      cancel: '否'
    },
    confirmSkip: {
      message: '你想做什么？',
      confirm: '跳过视频',
      cancel: '访问网站'
    },
    optIn: {
      message: '如果关闭广告，您将得不到奖励，您确定吗？',
      confirm: '跳过',
      cancel: '否'
    },
    discover: '#{name}',
    wait: '<span>请等待 <strong>#{count}</strong></span>',
    wait_close: '在 <strong>#{count} 秒后关闭</strong>',
    continue: '继续',
    click_bookmark: '添加到书签',
    call_to_action: '访问网站'
  },
  // portuges
  pt: {
    skipOrContinue: {
      message: 'Saltar o video ?',
      confirm: 'Saltar',
      cancel: 'Não'
    },
    confirmSkip: {
      message: 'O que queres fazer?',
      confirm: 'Saltar o video',
      cancel: 'Visita o website'
    },
    optIn: {
      message:
        'Se fechar esta publicidade, não irá receber a sua recompensa. Você tem certeza?',
      confirm: 'Saltar',
      cancel: 'Não'
    },
    discover: '#{name}',
    wait: '<span>Espera por favor conteúdo em <strong>#{count}</strong></span>',
    wait_close: 'Fecha em <strong>#{count} seg</strong>',
    continue: 'Continuar',
    click_bookmark: 'Adicionar aos favoritos',
    call_to_action: 'Visita o website'
  },
  // japan
  ja: {
    skipOrContinue: {
      message: '動画をスキップしますか？',
      confirm: 'スキップ',
      cancel: 'いいえ'
    },
    confirmSkip: {
      message: '何をしたいですか？',
      confirm: '動画をスキップする',
      cancel: 'ウェブサイトにアクセスする'
    },
    optIn: {
      message: '広告を閉じるとリワードをもらえません。よろしいですか？',
      confirm: 'スキップ',
      cancel: 'いいえ'
    },
    discover: '#{name}',
    wait: '<span><strong>#{count}</strong> 秒お待ちください</span>',
    wait_close: '<strong>#{count}</strong> 秒後に閉じる',
    continue: '進む',
    click_bookmark: 'ブックマークに追加',
    call_to_action: 'ウェブサイトにアクセスする'
  },
  // sweden
  sv: {
    skipOrContinue: {
      message: 'Hoppa över videon?',
      confirm: 'Hoppa',
      cancel: 'Nej'
    },
    confirmSkip: {
      message: 'Vad vill du göra ?',
      confirm: 'Hoppa över videoklippet',
      cancel: 'Besök webbplatsen'
    },
    optIn: {
      message: 'Om du stänger annonsen får du inte din belöning. Är du säker ?',
      confirm: 'Hoppa',
      cancel: 'Nej'
    },
    discover: '#{name}',
    wait:
      '<span>Vänligen vänta med ditt innehåll <strong>#{count}</strong></span>',
    wait_close: 'Stäng inom <strong>#{count} sekunder</strong>',
    continue: 'Fortsätta',
    click_bookmark: 'Klicka för bokmärke',
    call_to_action: 'Besök webbplatsen'
  },
  nl: {
    skipOrContinue: {
      message: 'Sla de video over?',
      confirm: 'Overspringen',
      cancel: 'Nee'
    },
    confirmSkip: {
      message: 'Wat wil je doen ?',
      confirm: 'Sla de video over',
      cancel: 'Bezoek de website'
    },
    optIn: {
      message:
        'Als u de advertentie sluit, ontvangt u uw beloning niet. Weet je het zeker ?',
      confirm: 'Overspringen',
      cancel: 'Nee'
    },
    discover: '<span>Ontdek <strong>#{name}</strong>.</span>',
    wait: '<span>Wacht alstublieft uw inhoud <strong>#{count}</strong></span>',
    wait_close: 'Sluit in <strong>#{count} sec</strong>',
    continue: 'Voortzetten',
    click_bookmark: 'Klik op bladwijzer',
    call_to_action: 'Bezoek de website'
  }
};

export default translations;
